let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k6PwY")).then(() => parcelRequire('ZNoty'));